// extracted by mini-css-extract-plugin
export var root = "_zo-0";
export var scroll = "_zo-1";
export var thumb = "_zo-3";
export var track = "_zo-2";